// Messages Manager Component
import React, { useState, useEffect } from 'react';
import { Trash2, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const MessagesManager = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchContacts(); }, []);

  const fetchContacts = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/admin/contacts`, { credentials: 'include' });
      if (response.ok) { const data = await response.json(); setContacts(data || []); }
    } catch (err) { console.error('Error fetching contacts:', err); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Supprimer ce message ?')) return;
    try {
      await fetch(`${BACKEND_URL}/api/admin/contacts/${id}`, { method: 'DELETE', credentials: 'include' });
      fetchContacts();
    } catch (err) { console.error('Error deleting contact:', err); }
  };

  if (loading) {
    return <div className="flex justify-center py-12"><Loader2 className="w-8 h-8 animate-spin text-slate-400" /></div>;
  }

  return (
    <div>
      <h2 className="text-2xl font-light text-slate-800 mb-6">Messages de Contact</h2>
      <div className="space-y-4">
        {contacts.map((contact) => (
          <div key={contact.id} className="border border-slate-200 rounded-lg p-4">
            <div className="flex justify-between items-start">
              <div>
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-medium text-slate-800">{contact.name}</h3>
                  <span className="text-sm text-slate-500">&lt;{contact.email}&gt;</span>
                </div>
                <p className="text-sm font-medium text-slate-700 mb-2">{contact.subject}</p>
                <p className="text-sm text-slate-600">{contact.message}</p>
                <p className="text-xs text-slate-400 mt-2">{new Date(contact.created_at).toLocaleString('fr-FR')}</p>
              </div>
              <Button variant="ghost" size="sm" onClick={() => handleDelete(contact.id)}><Trash2 className="w-4 h-4 text-red-500" /></Button>
            </div>
          </div>
        ))}
      </div>
      {contacts.length === 0 && <div className="text-center py-12 text-slate-500">Aucun message.</div>}
    </div>
  );
};

export default MessagesManager;
